import React from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var GreetingWrapper = styled.div.withConfig({
  displayName: "greeting-messagecomponent__GreetingWrapper",
  componentId: "sc-1si5evz-0"
})(["text-align:center;margin-bottom:24px;"]);
var GreetingTitle = styled.h2.withConfig({
  displayName: "greeting-messagecomponent__GreetingTitle",
  componentId: "sc-1si5evz-1"
})(["font-size:18px;font-weight:600;color:#2d3748;margin:0 0 6px 0;line-height:1.4;"]);
var GreetingSubtitle = styled.p.withConfig({
  displayName: "greeting-messagecomponent__GreetingSubtitle",
  componentId: "sc-1si5evz-2"
})(["font-size:14px;color:#718096;margin:0;line-height:1.5;"]);
export var GreetingMessage = function GreetingMessage(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Hi there! I'm Digibrick AI." : _ref$title,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === void 0 ? 'I’m your AI assistant for building forms. What kind of form would you like to build today?' : _ref$subtitle;
  return /*#__PURE__*/_jsxs(GreetingWrapper, {
    children: [/*#__PURE__*/_jsx(GreetingTitle, {
      children: title
    }), /*#__PURE__*/_jsx(GreetingSubtitle, {
      children: subtitle
    })]
  });
};